import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Intro from "@/components/site/Intro";
import Services from "@/components/site/Services";
import Packages from "@/components/site/Packages";
import Testimonial from "@/components/site/Testimonial";
import Agency from "@/components/site/Agency";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="relative">
      <Header />
      <Hero />
      <Intro />
      <Services />
      <Packages />
      <Testimonial />
      <Agency />
      <Contact />
      <Footer />
    </main>
  );
}
